import Reveal from "./Reveal";
import { useT } from "../../i18n/I18nContext";

const IMAGES = [
  "https://images.pexels.com/photos/33357444/pexels-photo-33357444.png",
  "https://images.pexels.com/photos/9062527/pexels-photo-9062527.jpeg",
  "https://images.unsplash.com/photo-1758691737278-3af15b37af48?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2OTV8MHwxfHNlYXJjaHwzfHxhc2lhbiUyMGNvcnBvcmF0ZSUyMG9mZmljZXxlbnwwfHx8fDE3Nzk4NzU3NjV8MA&ixlib=rb-4.1.0&q=85",
  "https://images.pexels.com/photos/4716814/pexels-photo-4716814.jpeg",
  "https://images.unsplash.com/photo-1504307651254-35680f356dfd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwxfHxhc2lhbiUyMGNvbnN0cnVjdGlvbiUyMHNpdGV8ZW58MHx8fHwxNzc5ODc1NzcxfDA&ixlib=rb-4.1.0&q=85",
  "https://images.unsplash.com/photo-1611662583223-04d6dc1c13f2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODF8MHwxfHNlYXJjaHwyfHxhc2lhbiUyMGNvbnN0cnVjdGlvbiUyMHNpdGV8ZW58MHx8fHwxNzc5ODc1NzcxfDA&ixlib=rb-4.1.0&q=85",
];

export const Portfolio = () => {
  const t = useT();
  return (
    <section
      id="portfolio"
      data-testid="portfolio-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal>
              <p className="text-xs font-bold uppercase tracking-[0.2em] text-[#2563EB]">
                {t.portfolio.eyebrow}
              </p>
            </Reveal>
            <Reveal delay={60}>
              <h2 className="mt-4 text-3xl sm:text-4xl lg:text-5xl font-bold text-[#0A2342] tracking-tight leading-[1.1]">
                {t.portfolio.title}
              </h2>
            </Reveal>
          </div>
          <Reveal delay={120}>
            <p className="max-w-md text-base text-slate-600 leading-relaxed">
              {t.portfolio.body}
            </p>
          </Reveal>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-7">
          {t.portfolio.items.map((p, i) => (
            <Reveal key={p.name} delay={70 * i}>
              <article
                data-testid={`portfolio-card-${i}`}
                className="group relative bg-white rounded-2xl border border-slate-200/70 overflow-hidden uv-card-hover h-full"
              >
                <div className="relative uv-img-zoom aspect-[4/3] bg-slate-100">
                  <img
                    src={IMAGES[i]}
                    alt={`${p.name} — ${p.industry}`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A2342]/70 via-[#0A2342]/0 to-transparent opacity-80" />
                  <span className="absolute top-4 left-4 inline-flex items-center rounded-full bg-white/95 backdrop-blur px-3 py-1 text-[11px] font-bold uppercase tracking-wider text-[#0A2342]">
                    {p.industry}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-start justify-between gap-3">
                    <h3 className="text-lg font-bold text-[#0A2342] leading-snug">
                      {p.name}
                    </h3>
                    <span className="shrink-0 text-xs font-semibold text-slate-500">
                      {p.location}
                    </span>
                  </div>
                  <p className="mt-3 text-sm text-slate-600 leading-relaxed">
                    {p.result}
                  </p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Portfolio;
